// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-row_manage_slots_settings {
    margin-bottom: 1.5rem;
  }
  
  .slot-label_manage_slots_settings {
    font-size: 1rem;
    font-weight: 600;
    color: #4a4a4a;
    margin-bottom: 0.5rem;
    display: inline-block;
  }
  
  .slot-message_manage_slots_settings {
    font-style: italic;
    color: #999;
    font-size: 0.95rem;
    padding: 0.25rem 0;
  }
  
  .date-slider-bar_manage_slots_settings {
    display: flex;
    align-items: center;
    background-color: #f5f9ff;
    border: 1px solid #d8e2ee;
    border-radius: 10px;
    padding: 0.75rem 1rem;
    gap: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    overflow: hidden;
  }
  
  .date-nav-btn_manage_slots_settings {
    background-color: #ffffff;
    border: 1px solid #ccc;
    font-size: 1.4rem;
    color: var(--clr-primary-5);
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .date-nav-btn_manage_slots_settings:hover:enabled {
    background-color: #e6f2ff;
  }
  
  .date-nav-btn_manage_slots_settings:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .date-capsule-row_manage_slots_settings {
    display: flex;
    gap: 0.5rem;
    flex: 1 1;
    justify-content: space-between;
  }
  
  .date-capsule_manage_slots_settings {
    flex: 1 1;
    text-align: center;
    background-color: #ffffff;
    border: 1px solid #cfd8e0;
    border-radius: 8px;
    padding: 0.6rem 0.75rem;
    font-size: 0.95rem;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .date-capsule_manage_slots_settings:hover {
    background-color: #f0f7ff;
    border-color: var(--clr-primary-5)
  }
  
  .date-capsule_manage_slots_settings.selected {
    background-color: var(--clr-primary-5);
    color: #ffffff;
    font-weight: 600;
    border-color:var(--clr-primary-8);
  }
  
  /* Responsive */
  @media (max-width: 768px) {
    .date-capsule_manage_slots_settings {
      font-size: 0.8rem;
      padding: 0.4rem 0.5rem;
    }
  
    .date-slider-bar_manage_slots_settings {
      flex-direction: column;
      align-items: stretch;
      gap: 0.75rem;
    }
  
    .date-capsule-row_manage_slots_settings {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Configurations/tabs/ManageSlots/manageSlotsParts/styles/DateSelector.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;IACT,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,SAAO;IACP,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB;EACF;;EAEA;IACE,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,eAAe;EACf;IACE;MACE,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,sBAAsB;MACtB,oBAAoB;MACpB,YAAY;IACd;;IAEA;MACE,eAAe;MACf,uBAAuB;IACzB;EACF","sourcesContent":[".slot-row_manage_slots_settings {\n    margin-bottom: 1.5rem;\n  }\n  \n  .slot-label_manage_slots_settings {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #4a4a4a;\n    margin-bottom: 0.5rem;\n    display: inline-block;\n  }\n  \n  .slot-message_manage_slots_settings {\n    font-style: italic;\n    color: #999;\n    font-size: 0.95rem;\n    padding: 0.25rem 0;\n  }\n  \n  .date-slider-bar_manage_slots_settings {\n    display: flex;\n    align-items: center;\n    background-color: #f5f9ff;\n    border: 1px solid #d8e2ee;\n    border-radius: 10px;\n    padding: 0.75rem 1rem;\n    gap: 1rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n    overflow: hidden;\n  }\n  \n  .date-nav-btn_manage_slots_settings {\n    background-color: #ffffff;\n    border: 1px solid #ccc;\n    font-size: 1.4rem;\n    color: var(--clr-primary-5);\n    padding: 0.5rem 0.75rem;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .date-nav-btn_manage_slots_settings:hover:enabled {\n    background-color: #e6f2ff;\n  }\n  \n  .date-nav-btn_manage_slots_settings:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  .date-capsule-row_manage_slots_settings {\n    display: flex;\n    gap: 0.5rem;\n    flex: 1;\n    justify-content: space-between;\n  }\n  \n  .date-capsule_manage_slots_settings {\n    flex: 1;\n    text-align: center;\n    background-color: #ffffff;\n    border: 1px solid #cfd8e0;\n    border-radius: 8px;\n    padding: 0.6rem 0.75rem;\n    font-size: 0.95rem;\n    color: #333;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n  \n  .date-capsule_manage_slots_settings:hover {\n    background-color: #f0f7ff;\n    border-color: var(--clr-primary-5)\n  }\n  \n  .date-capsule_manage_slots_settings.selected {\n    background-color: var(--clr-primary-5);\n    color: #ffffff;\n    font-weight: 600;\n    border-color:var(--clr-primary-8);\n  }\n  \n  /* Responsive */\n  @media (max-width: 768px) {\n    .date-capsule_manage_slots_settings {\n      font-size: 0.8rem;\n      padding: 0.4rem 0.5rem;\n    }\n  \n    .date-slider-bar_manage_slots_settings {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 0.75rem;\n    }\n  \n    .date-capsule-row_manage_slots_settings {\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
